// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangeEmailRoute_wrapper","title":"ChangeEmailRoute_title"};